import type { SVGProps } from "react";

export function Ear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 8a6 6 0 1 1 12 0v7a4 4 0 0 1-8 0v-1" />
      <path d="M10 12a2 2 0 0 0 4 0" />
    </svg>
  );
}
